let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bWqqo")).then(() => parcelRequire('54WGm'));